module.exports = __webpack_public_path__ + "img/D201607_3.2a3bf807.jpg";